import { render, staticRenderFns } from "./router-list.vue?vue&type=template&id=5eb0c2d6&scoped=true&"
import script from "./router-list.vue?vue&type=script&lang=js&"
export * from "./router-list.vue?vue&type=script&lang=js&"
import style0 from "./router-list.vue?vue&type=style&index=0&id=5eb0c2d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb0c2d6",
  null
  
)

export default component.exports